export default __webpack_public_path__ + "images/acd478fd05709ed119dc13cec26305da.svg";